<template>
    <div class="main">
        <Steps :index="1" product-name="定制-建工雇主责任险按项目方案" />
        <ApplicantInfo :info="info" title="投保企业信息" v-if="info" />
        <RecognizeInfo :info="info" class="mt20" />
        <InvoiceInfo :info="info.invoiceInfo" v-if="info.invoiceInfo" />
        <div class="mt15 agree">
    	<Checkbox v-model="agree">我已经阅读并同意</Checkbox>
    	<a href="/static/pdf/haierProduct/阳光建设施工企业雇主责任保险条款.pdf" target="_blank">《阳光建设施工企业雇主责任保险条款》</a>
    </div>
        <div class="mt20 center">
            <p>实际支付：<span class="price">{{info.premium}}元</span></p>
            <p class="mt10">
                <Button type="primary" @click="toPay" :disabled="!agree"  :loading="loading">提交</Button>
            </p>
        </div>
    </div>
</template>
<script>
    import RecognizeInfo from './RecognizeInfo'
    import ApplicantInfo from './common/ApplicantInfo'
    import InvoiceInfo from './common/InvoiceInfo'
    import Steps from '../common/Steps'
    import InsuranceSlip from '../common/InsuranceSlip'
    import track from "@/mixin/track";
    export default {
        mixins:[ track ],
        components: { RecognizeInfo, ApplicantInfo, InvoiceInfo, Steps, InsuranceSlip },
        data () {
            return {
                info: {
                    id: this.$route.params.id,
                },
                loading: false,
                agree: false,
                id: this.$route.params.id
            }
        },
        created () {
            if (this.id) {
                this.getInfo()
            }
        },
        mounted () {
            // 回溯 开始录制
            this.$nextTick(this.startRecord);
        },
        methods: {
            // 根据id获取信息
            getInfo () {
                this.$axios.post('/broker/insurance/application/detail', {
                    applicationId: this.id
                }).then(res => {
                    this.info = res;
                    this.info.url = []
                    if (this.info.extraInfo.businessLicenseUrl) {
                        this.info.url = this.info.extraInfo.businessLicenseUrl.split(",")
                    }
                    this.info.url_ = []
                    if (this.info.extraInfo.projectContract) {
                        this.info.url_ = this.info.extraInfo.projectContract.split(",")
                    }
                    console.log(' this.info确认信息', this.info)
                    if (res.list && res.list.length > 0) {
                        this.info.subjoinAllDay = res.list[0].subjoinAllDay
                        this.info.subjoinOwnMedicine = res.list[0].subjoinOwnMedicine
                        this.info.subjoinProportionAdj = res.list[0].subjoinProportionAdj
                    }
                });
            },
            async toPay () {
                this.loading = true;
                this.$axios.post('/broker/insurance/application/confirm', {
                    applicationId: this.id
                }).then(async res => {
                    // 回溯 停止录制
                    await this.stopRecord({
                        policy_id:this.info.applicationNo
                    });
                    this.toast('提交成功')
                    this.loading = false;
                    this.$router.push('/my/customized/task')
                })
            }
        }
    }
</script>
<style scoped lang="less">
    .main {
        background: #fff;
        margin-top: 15px;
        padding: 30px 40px;
    }

    .mt20 {
        font-size: 25px;
        line-height: 1.8;
    }

    span.price {
        color: #FF0000;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/Confirm.vue